<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="purchaseAirlinesObj.isActive?'tag is-success':'tag'">Standard rule</span> 
                <div class="right-content">
                    <div class="lefttext">
                        <p class="paragrapgh">Instant purchase airlines </p>
                        <p>Trigger for any instant purchase airlines / low cost carriers </p>
                    </div>
                    <div class="allbtns">
                        <b-switch 
                            :rounded="true" 
                            :value="purchaseAirlinesObj.isActive" 
                            v-model="purchaseAirlinesObj.isActive"
                            @input="hideInstantPurchase" 
                            :left-label="true"
                            >{{ purchaseAirlinesObj.isActive ? 'Active' : 'Inactive' }}
                        </b-switch>
                    </div>
                </div>
            </div>
    </div>
</template>
<script>
export default{
    name:"",
    props: {
    value: {
      type: [Object],
    },
  },
    data(){
        return{
          purchaseAirlinesObj:this.value?this.value:{
                    name: "hideInstantPurchase",
                    isActive: false,
                    type:'air',
                    message:'',
          }
        }
    },
    methods:{
        hideInstantPurchase(){
            this.$emit('hideInstantPurchase',this.purchaseAirlinesObj)
        }
    },
    mounted(){
        this.purchaseAirlinesObj.type='all';
        this.purchaseAirlinesObj.message=this.buildMessage;
        this.$emit('hideInstantPurchase',this.purchaseAirlinesObj)

    },
    computed:{
        buildMessage(){

            var string ='Trigger for any instant purchase airlines / low cost carriers';

            return string;
        }
    },
    watch: {
    value: {
      handler(newVal, prevVal) {
        this.purchaseAirlinesObj = this.value;
        this.purchaseAirlinesObj.type='air';
        this.purchaseAirlinesObj.message=this.buildMessage;
        this.$emit('hideInstantPurchase',this.purchaseAirlinesObj)

      },
      deep: true,
    },
  },
}
</script>